import { app } from "./app";
import { illusbills } from "./illusbills";
import { illusion } from "./illusion";
import { illusnacci } from "./illusnacci";
import { intel } from "./intel";
import { lexicon } from "./lexicon";
import { mail } from "./mail";
import { catalog } from "./catalog";
import { domain } from "./domain";
import { setup } from "./setup";
import { ui } from "./ui";

export type Locale = "de" | "en";

/** Merged dictionaries. Each module exports `{ en, de }` with flat keys. */
export const MESSAGES: Record<Locale, Record<string, string>> = {
  en: { ...domain.en, ...catalog.en, ...app.en, ...intel.en, ...setup.en, ...mail.en, ...illusbills.en, ...illusion.en, ...illusnacci.en, ...lexicon.en, ...ui.en },
  de: { ...domain.de, ...catalog.de, ...app.de, ...intel.de, ...setup.de, ...mail.de, ...illusbills.de, ...illusion.de, ...illusnacci.de, ...lexicon.de, ...ui.de },
};
